import alexiaBlackLogoSm from './images/alexia-black-logo-sm.png';
import alexiaBlackLogoMd from './images/alexia-black-logo-md.png';
import alexiaGoldLogoLg from './images/alexia-gold-logo-lg.png';
import alexiaGoldLogoSm from './images/alexia-gold-logo-sm.png';

import placeholderImage from './images/placeholder-image.jpg';
import fbAdPlacerSponsor from './images/fb-ad-placer-sponsor.png';
import fbAdPlacerBottomDesktop from './images/fb-ad-placer-bottom-desktop.png';
import fbAdPlacerLikeBtn from './images/fb-ad-placer-like-btn.png';
import fbAdPlacerSafeImage from './images/fb-ad-placer-safe-image.png';
import patentPending from './images/patent-seal_w.png';
import alexiaLogoWhite from './images/alexia-logo-White.png';
import constellationLogoBlack from './images/constellation-wide-logo-blank.png';
import lineageCheckmark from './images/lineage-checkmark.png';
import dotLoader from './images/dot-loader.gif';
import loginBackground from './images/login_background.png';
import alexiaLogo from './images/alexia-logo.png';
import userPlaceholder from './images/user-placeholder.png';
import canvasType from './images/CanvasType.jpg';
import collectionType from './images/CollectionType.jpg';
import carouselType from './images/CarouselType.jpg';
import videoType from './images/VideoType.jpg';
import stillType from './images/StillType.jpg';
import daaType from './images/DAAType.jpg';
import daaTypeCard from './images/DAATypeCard.jpg';
import missingThumbnail from './images/missingThumbnail.jpg';

export default {
  constellationLogoBlack,
  alexiaBlackLogoSm,
  alexiaBlackLogoMd,
  alexiaGoldLogoLg,
  alexiaGoldLogoSm,
  placeholderImage,
  fbAdPlacerSponsor,
  fbAdPlacerBottomDesktop,
  fbAdPlacerLikeBtn,
  fbAdPlacerSafeImage,
  patentPending,
  alexiaLogoWhite,
  lineageCheckmark,
  dotLoader,
  loginBackground,
  alexiaLogo,
  userPlaceholder,
  canvasType,
  collectionType,
  carouselType,
  daaType,
  videoType,
  stillType,
  daaTypeCard,
  missingThumbnail
};



// WEBPACK FOOTER //
// ./src/assets/Images.js